import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { SelfInvoiceDetailsViewProps } from "models/propTypes/selfInvoicePropTypes";
//#endregion
//#region components
import { PageLayouts, EntityTitle } from "components/common";
import SelfInvoiceFileViewer from "./fileViewer";
import SelfInvoiceBanner from "./banner";
import { useSelfInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SelfInvoiceDetailsView: React.FC<SelfInvoiceDetailsViewProps> = (props) => {
  const { selfInvoice } = props;

  const selfInvoiceService = useSelfInvoiceService();

  const [relatedInvoiceId, setRelatedInvoiceId] = React.useState<number>();

  React.useEffect(() => {
    selfInvoiceService.getCustomerInvoiceId(selfInvoice.id!).then((res) => setRelatedInvoiceId(res));
  }, [selfInvoice]);

  const displayType = React.useMemo(() => {
    if (selfInvoice === undefined) return StyleEnums.DisplayType.Info;

    switch (selfInvoice?.state) {
      case WintSuperkollAPIModel.SelfInvoiceState.Created:
        return StyleEnums.DisplayType.Success;
      case WintSuperkollAPIModel.SelfInvoiceState.Rejected:
      case WintSuperkollAPIModel.SelfInvoiceState.Deleted:
        return StyleEnums.DisplayType.Danger;
      default:
        return StyleEnums.DisplayType.Info;
    }
  }, [selfInvoice?.state]);

  return (
    <PageLayouts.EntityViewLayout
      displayType={displayType}
      upperLeftComponent={
        <EntityTitle
          subTitle={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.SelfInvoice)}
          title={selfInvoice.customerName ?? ""}
        />
      }
      upperRightComponent={<></>}
      lowerLeftComponent={<SelfInvoiceFileViewer invoice={selfInvoice} />}
      footer={<></>}
    >
      <SelfInvoiceBanner selfInvoice={selfInvoice} displayType={displayType} relatedInvoiceId={relatedInvoiceId} />
    </PageLayouts.EntityViewLayout>
  );
};
export default SelfInvoiceDetailsView;
